import {calculateBookingPriceQuery} from './calculate-booking-price'
import {calculateSplitBookingPriceQuery} from './calculate-split-booking-price'
import {checkSplitBookingPaymentPartsMutation} from './check-split-booking-payd-parts'
import {
  createClassBookingDraftMutation,
  createClassBookingMutation,
  createClassBookingPayByTokenMutation,
} from './create-class-booking.mutation'
import {
  createInstructorBookingMutation,
  createInstructorBookingPayByTokenMutation,
} from './create-instructor-booking.mutation'
import {
  createServiceBookingDraftMutation,
  createServiceBookingMutation,
  createServiceBookingPayByTokenMutation,
} from './create-service-booking.mutation'
import {getAvailableDaysByWeekQuery} from './get-available-days-by-week'
import {getBookingQuery, getDraftEntityQuery} from './get-booking'
import {getInstructorServicesQuery} from './get-instructor-services'
import {getPlayspacesQuery} from './get-playspaces'
import {getServiceTimeslotGridQuery} from './get-service-timeslot-grid'
import {getUserBookingsQuery} from './get-user-bookings'
import {getVenueClassesSessionsByDateQuery} from './get-venue-class-sessions-by-date'
import {getVenueInstructorsQuery} from './get-venue-instructors'
import {getVenueServicesQuery} from './get-venue-services'
import {
  createSplitPaymentBookingDraftMutation,
  updateServiceBookingSplitPayByTokenMutation,
  updateServiceBookingSplitPaySubscriptionMutation,
} from './update-pay-split-booking.mutation'

export const BookingQueries = {
  getBookingQuery,
  getPlayspacesQuery,
  getDraftEntityQuery,
  getUserBookingsQuery,
  getVenueServicesQuery,
  getVenueInstructorsQuery,
  getInstructorServicesQuery,
  calculateBookingPriceQuery,
  getServiceTimeslotGridQuery,
  getAvailableDaysByWeekQuery,
  calculateSplitBookingPriceQuery,
  getVenueClassesSessionsByDateQuery,
}

export const BookingMutations = {
  createClassBookingMutation,
  createServiceBookingMutation,
  createClassBookingDraftMutation,
  createInstructorBookingMutation,
  createServiceBookingDraftMutation,
  createClassBookingPayByTokenMutation,
  createSplitPaymentBookingDraftMutation,
  createServiceBookingPayByTokenMutation,
  createInstructorBookingPayByTokenMutation,
  updateServiceBookingSplitPayByTokenMutation,
  updateServiceBookingSplitPaySubscriptionMutation,
  checkSplitBookingPaymentPartsMutation,
}
